/*@ngInject*/
const UnselectedFilterController = function ($scope, coreConstant, advancedFilterModel, localization,
                                             formatUtil) {

    this.$onInit = function () {
        this.isOpen = true;
        localization.getTranslationsByKeys([ this.translationsKey, 'advancedFilter' ]).then((translations) => {
            this.placeholder = _.get(translations.unselectedFilter, 'placeholder') || translations.placeholder;
        });
    };

    this.formatAsSelector = function (nameString) {
        return nameString ? formatUtil.formatAsSelector(nameString) : '';
    };

    this.handleClick = function () {
        this.filteredItemsList = this.filterModel.unselectedFilterCriterionTemplates;
    };

    this.handleSelect = function ($select) {
        let selectedFilterCriterionTemplate = $select.selected;
        advancedFilterModel.selectFilterCriterion(this.advancedFilterType, selectedFilterCriterionTemplate.id);
        $select.selected = null;
    };

    this.filterItems = function (searchText) {
        let filteredItemsList = [],
            itemList = !_.isNil(this.filterModel)? this.filterModel.unselectedFilterCriterionTemplates:[];

        if (!_.isEmpty(searchText)) {
            filteredItemsList = _.filter(itemList, function (item) {
                return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
            });
        }
        else if (_.isArray(itemList)) {
            filteredItemsList = itemList;
        }

        this.filteredItemsList = filteredItemsList;
    };

    $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
        if (criterionTemplateId === this.criterionTemplate.id) {
            this.criterionTemplate.value = '';
        }
    }.bind(this));
};

angular.module('umCore')
    .controller('unselectedFilterController', UnselectedFilterController);
